import styles from "./styles.module.css";
import Lottie from "lottie-react";
import cx from "classnames";
import { useEffect } from "react";

let counter = 0;
let pauseCounter = 0;

function GainfulLoading() {
  useEffect(() => {
    const gainful = document.getElementById("gainful-loader");

    const interval = setInterval(() => {
      if (counter >= gainful.children.length) {
        if (pauseCounter < 5) {
          pauseCounter += 1;
          return;
        }
        pauseCounter = 0;
        counter = 0;
        for (let i = 0; i < gainful.children.length; i += 1) {
          gainful.children[i].style.opacity = 0.3;
        }
        return;
      }
      for (let i = 0; i <= counter; i += 1) {
        gainful.children[i].style.opacity = 1;
      }
      counter += 1;
    }, 200);
    return () => clearInterval(interval);
  }, []);
  return (
    <>
      <div className={styles.loadingscreen}></div>
      <div className={cx(styles.loading, styles.loading_icons_animation)}>
        <div className={styles.gainful} id="gainful-loader">
          <span>G</span>
          <span>A</span>
          <span>I</span>
          <span>N</span>
          <span>F</span>
          <span>U</span>
          <span>L</span>
        </div>
      </div>
    </>
  );
}

export default GainfulLoading;
